import React from 'react'
import { ARDebtorLedgerDetailbyDocDateParamsForm } from './Parameters/ARDebtorLedgerDetailByDocDateParamsForm'
import { ARDigitalReportSubmenu } from './ARDigitalReportSubmenu'
import { ARDebtorLedgerDetailByDocDateReport } from './GeneratedReport/ARDebtorLedgerDetailByDocDateReport'
import { ARStatementOfAccountParamsForm } from './Parameters/ARStatementOfAccountParamsForm'
import { ARStatementOfAccountReport } from './GeneratedReport/ARStatementOfAccountReport'
import { ARDebtorAgingSummarybyTrxDateParamsForm } from './Parameters/ARDebtorAgingSummaryByTrxDateParamsForm'
import { ARDebtorAgingSummaryByTrxDateReport } from './GeneratedReport/ARDebtorAgingSummaryByTrxDateReport'
import { ARDebtorAgingDetailByTrxDate } from './GeneratedReport/ARDebtorAgingDetailByTrxDate'
import { ARDebtorAgingDetailByTrxDateForms } from './Parameters/ARDebtorAgingDetailByTrxDateForms'
import { ARDebtorControlSummary } from './GeneratedReport/ARDebtorControlSummary'
import { ARDebtorControlSummaryForms } from './Parameters/ARDebtorControlSummaryForms'
import { ARDebtorControlDetailForms } from './Parameters/ARDebtorControlDetailForms'
import { ARDebtorControlDetail } from './GeneratedReport/ARDebtorControlDetail'
import { ARDebtorAgingSummarybyDocDateParamsForm } from './Parameters/ARDebtorAgingSummaryByDocDateParamsForm'
import { ARDebtorAgingSummaryByDocDateReport } from './GeneratedReport/ARDebtorAgingSummaryByDocDateReport'
import { AREInvoiceListingParamsForm } from './Parameters/AREInvoiceListingParamsForm'
import { AREInvoiceListingReport } from './GeneratedReport/AREInvoiceListingReport'
import { ARConsolidatedEInvoiceParamsForm } from './Parameters/ARConsolidatedEInvoiceParamsForm'
import { ARConsolidatedEInvoiceReport } from './GeneratedReport/ARConsolidatedEInvoiceReport'
import { ARDebtorLedgerDetailbyTrxDateParamsForm } from './Parameters/ARDebtorLedgerDetailByTrxDateParamsForm'
import { ARDebtorLedgerDetailByTrxDateReport } from './GeneratedReport/ARDebtorLedgerDetailByTrxDateReport'
import { SSTTrackingReportParamsForm } from './Parameters/SSTTrackingReportParamsForm'
import { SSTTrackingReport } from './GeneratedReport/SSTTrackingReport'
import { SSTExemptedTrackingReportParamsForm } from './Parameters/SSTExemptedTrackingReportParamsForm'
import { SSTExemptedTrackingReport } from './GeneratedReport/SSTExemptedTrackingReport'
import { SSTPayableReportParamsForm } from './Parameters/SSTPayableReportParamsForm'
import { SSTPayableReport } from './GeneratedReport/SSTPayableReport'
import { CollectionAllocationDetailsReportParamsForm } from './Parameters/CollectionAllocationDetailsReportParamsForm'
import { CollectionAllocationDetailsReport } from './GeneratedReport/CollectionAllocationDetailsReport'
import { AmortisationScheduleParamsForm } from './Parameters/AmortisationScheduleParamsForm'
import { AmortisationScheduleReport } from './GeneratedReport/AmortisationScheduleReport'
import { SSTPayableReportExParamsForm } from './Parameters/SSTPayableReportExParamsForm'
import { SSTPayableReportEx } from './GeneratedReport/SSTPayableReportEx'

const arDigitalReportRoutes = [
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable',
    },
    component: <ARDigitalReportSubmenu mode="account-receivable" />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-ledger-detail-by-doc-date/parameters',
    },
    component: <ARDebtorLedgerDetailbyDocDateParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-ledger-detail-by-doc-date/generated',
    },
    component: <ARDebtorLedgerDetailByDocDateReport />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-ledger-detail-by-trx-date/parameters',
    },
    component: <ARDebtorLedgerDetailbyTrxDateParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-ledger-detail-by-trx-date/generated',
    },
    component: <ARDebtorLedgerDetailByTrxDateReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-statement-of-account/parameters',
    },
    component: <ARStatementOfAccountParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-statement-of-account/generated',
    },
    component: <ARStatementOfAccountReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-summary-trx-date/parameters',
    },
    component: <ARDebtorAgingSummarybyTrxDateParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-summary-trx-date/generated',
    },
    component: <ARDebtorAgingSummaryByTrxDateReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-summary-doc-date/parameters',
    },
    component: <ARDebtorAgingSummarybyDocDateParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-summary-doc-date/generated',
    },
    component: <ARDebtorAgingSummaryByDocDateReport />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-detail-trx-date/parameters',
    },
    component: <ARDebtorAgingDetailByTrxDateForms />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-aging-detail-trx-date/generated',
    },
    component: <ARDebtorAgingDetailByTrxDate />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-control-summary/parameters',
    },
    component: <ARDebtorControlSummaryForms />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-control-summary/generated',
    },
    component: <ARDebtorControlSummary />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-control-detail/parameters',
    },
    component: <ARDebtorControlDetailForms />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-debtor-control-detail/generated',
    },
    component: <ARDebtorControlDetail />,
  },

  // e-InvoiceListing
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/e-invoice-listing/parameters',
    },
    component: <AREInvoiceListingParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/e-invoice-listing/generated',
    },
    component: <AREInvoiceListingReport />,
  },

  // ARConsolidatedEInvoice
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-consolidated-einvoice/parameters',
    },
    component: <ARConsolidatedEInvoiceParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/ar-consolidated-einvoice/generated',
    },
    component: <ARConsolidatedEInvoiceReport />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/sst-tracking-report/parameters',
    },
    component: <SSTTrackingReportParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/sst-tracking-report/generated',
    },
    component: <SSTTrackingReport />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/sst-exempted-tracking-report/parameters',
    },
    component: <SSTExemptedTrackingReportParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/sst-exempted-tracking-report/generated',
    },
    component: <SSTExemptedTrackingReport />,
  },

  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/sst-payable-report/parameters',
    },
    component: <SSTPayableReportParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/sst-payable-report/generated',
    },
    component: <SSTPayableReport />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/sst-payable-reports/parameters',
    },
    component: <SSTPayableReportExParamsForm />,
  },
  {
    props: {
      exact: true,
      path: '/digital-reports/account-receivable/sst-payable-reports/generated',
    },
    component: <SSTPayableReportEx />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/collection-allocation-details-report/parameters',
    },
    component: <CollectionAllocationDetailsReportParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/collection-allocation-details-report/generated',
    },
    component: <CollectionAllocationDetailsReport />,
  },

  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/amortisation-schedule-report/parameters',
    },
    component: <AmortisationScheduleParamsForm />,
  },
  {
    props: {
      exact: true,
      path:
        '/digital-reports/account-receivable/amortisation-schedule-report/generated',
    },
    component: <AmortisationScheduleReport />,
  },
]

export default arDigitalReportRoutes
